import { Action } from 'redux';

import { RevertToDefaultLabel } from '~src/bootstrap/redux/actions/AppActionTypes';
import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';

export interface RevertToDefaultLabelAction extends Action {
    item: ILabelValueInfo;
}

export function revertToDefaultLabelAction(item: RevertToDefaultLabelAction['item']): RevertToDefaultLabelAction {
    return {
        type: RevertToDefaultLabel,
        item
    };
}